module.exports = __webpack_public_path__ + "media/application/images/icons/right-arrow-38ffed56964dad07ab5ccb142398ff78.svg";